import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

import { replacefigureColors } from '../components/SlideComponents/slideUtil';
import backendService from '../services/backendService';
import { SUPPORTED_IMAGE_MIMETYPES } from '../utils/fileDropUtils';
import { CropConfig } from '../utils/imageCropUtils';
import { createGameImageCacheKey } from './useMediaPreFetcher';

function useSvgImage({
  fileId,
  cropConfig,
  fileMimetype,
  isDiscoverTemplate,
  isAuthenticated,
  isOwner,
  colors,
}: {
  fileId?: string | null;
  cropConfig?: CropConfig | null;
  fileMimetype?: string | null;
  isDiscoverTemplate: boolean;
  isAuthenticated: boolean;
  isOwner: boolean;
  colors: string[];
}) {
  const { data, isFetching, error, isSuccess } = useQuery({
    queryKey: [...createGameImageCacheKey(fileId, cropConfig), fileMimetype],

    queryFn: async () => {
      if (fileMimetype === 'image/svg+xml') {
        if (fileId) {
          return backendService.instance.gameFiles.fetchSvgImage({
            fileId,
            isFromDiscover: isDiscoverTemplate,
            isAuthenticated,
            cropConfig,
            isOwner,
          });
        }
      }
    },

    enabled:
      Boolean(fileId) &&
      !!fileMimetype &&
      !!SUPPORTED_IMAGE_MIMETYPES.includes(fileMimetype),

    staleTime: 1000 * 60 * 60
  });

  const svgText = useMemo(() => {
    return replacefigureColors(data, colors);
  }, [data, colors]);

  return {
    svgText,
    error,
    isLoading: isFetching,
    isSuccess,
  };
}

export default useSvgImage;
